import React, { useState } from "react";
import { Tabs } from "../../../../CommonComponents";
import AppRoles from "./AppRoleGrid/AppRoles";
import EditRoles from "./AddEditRole/AddEditRole";
import { PivotItem } from "@fluentui/react";

const AppRolesContainer = () => {
  const [selectedKey, setSelectedKey] = React.useState("app-listing");
  const [selectedRole, setSelectedRole] = useState("");

  const handleLinkClick = (item?: PivotItem) => {
    if (item) {
      setSelectedKey(item.props.itemKey!);
    }
  };

  const tabItems = [
    {
      itemKey: "apps-roles",
      headerText: "Apps And Roles",
      content: (
        <AppRoles
          setSelectedKey={setSelectedKey}
          setSelectedRole={setSelectedRole}
          selectedRole={selectedRole}
        />
      ),
    },
    {
      itemKey: "add-app-role",
      headerText: "View Role Based Permissions",
      content: <EditRoles selectedRole={selectedRole} setSelectedKey={setSelectedKey}/>,
    },
  ];
  return (
    <div className="adminCardClass ">
      <div className="right-block">
        <div>
          <Tabs
            className={`custom-tab `}
            tabItems={tabItems}
            selectedKey={selectedKey}
            handleLinkClick={handleLinkClick}
           data-attribute="AppRoles_container_Default_Tabs" />
        </div>
      </div>
    </div>
  );
};

export default AppRolesContainer;
